import type { MeResponse, ResearchRecord } from "@pokifolio/contracts";

/**
 * Whether the signed-in person may change a part of the record (`what`, e.g. "the condition check"), and if not,
 * why. The same rules as the server: drafts only, by the owner or someone allowed to edit any research.
 */
export function editRule(
  research: ResearchRecord,
  me: MeResponse,
  what: string,
): { allowed: boolean; reason: string | null } {
  if (research.status !== "draft") {
    return {
      allowed: false,
      reason: `${capitalise(what)} can only be changed while the research is a draft.`,
    };
  }
  const isOwner = research.owner.id === me.user.id;
  const allowed =
    me.permissions.includes("research.update_any") ||
    (isOwner && me.permissions.includes("research.update_own"));
  return allowed
    ? { allowed: true, reason: null }
    : { allowed: false, reason: `Only ${research.owner.name}, who saved this, can change ${what}.` };
}

const capitalise = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);
